<template>
  <div class="zg-logo-cards">
    <zg-logo-card
      v-for="(item, index) in items"
      :key="index"
      :image="item.image"
      :link="item.link"
      :text="item.text"
      :background="background"
    />
  </div>
</template>

<script>
  import module from '../../mixins/module.js'
  import ZgLogoCard from '../ZgLogoCard/ZgLogoCard.vue'

  export default {
    name: 'ZgLogoCards',
    components: {
      ZgLogoCard
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true,
        validator: items => items?.length > 0
      },
      background: {
        type: String,
        required: false,
        default: 'beige'
      }
    }
  }
</script>

<style lang="scss" scoped>
  $gap: rem(24px);

  .zg-logo-cards {
    display: flex;
    flex-direction: column;
    gap: $gap;

    @include mq(medium) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    & > a,
    & > div {
      width: 100%;

      @include mq(medium) {
        flex-basis: calc(100% / 3 - (#{$gap} * 2 / 3));
      }
    }
  }
</style>
